import React, { useState, useEffect } from "react";

import { getGrammarData } from "../../api/services/ai";
import { useNavigate } from "react-router-dom";

const regex = /\*([^*]+)\*/g;

const boldText = (text) => {
  const regex = /\*([^*]+)\*/g;
  return text
    .split(regex)
    .map((part, index) =>
      index % 2 === 0 ? part : <strong key={index}>{part}</strong>,
    );
};

const GrammarCompare = ({ data }) => {
  const isPrompt = Boolean(data?.Count);

  const { original, reason, corrected, Sentences = [], Count } = data || {};

  const errorType = data?.["Error Type"] || "";

  return (
    <div>
      {isPrompt && (
        <div className="flex flex-col bg-gray-100 p-4 rounded-t-lg">
          <span className="text-left font-bold text-[14px] text-black">
            {errorType.replace(/^#|#$/g, "")}
          </span>
          <span className="text-left font-sans text-[12px] text-darkBlue3 mt-0.5">{`Instances Found: ${Count}`}</span>
        </div>
      )}
      {isPrompt ? (
        Sentences.map((sentence, idx) => (
          <div key={idx} className="flex flex-col">
            <div
              className={`flex flex-col p-5 border border-grey2 border-b-0 leading-[150%]`}
            >
              <div className="flex space-x-4">
                <img
                  className="h-6 w-6"
                  alt="tick"
                  src={require("../../assets/icons/info-filled-orange.png")}
                />
                <div className="flex flex-col space-y-1">
                  <h1 className="uppercase text-base font-bold text-darkgray font-sans">
                    original
                  </h1>
                  <p className="text-darkgray text-base font-sans">
                    {boldText(sentence?.Original)}
                  </p>
                </div>
              </div>
            </div>
            <div
              className={`flex p-5 border border-grey2 border-t-0 space-x-4 leading-[150%]${sentence?.Reason ? " border-b-0" : Sentences.length - 1 === idx ? " rounded-b-lg" : ""}`}
            >
              <img
                className="h-6 w-6"
                alt="tick"
                src={require("../../assets/icons/tick-filled-green.png")}
              />
              <div className="flex flex-col space-y-1">
                <h1 className="uppercase text-base font-bold text-darkgray font-sans">
                  suggested
                </h1>
                <p className="text-darkgray text-base font-sans">
                  {boldText(sentence?.Corrected)}
                </p>
              </div>
            </div>
            {sentence?.Reason && (
              <div
                className={`bg-green3 flex p-5 border border-grey2 border-t-0 space-x-4 leading-[150%] ${Sentences.length - 1 === idx && "rounded-b-lg"}`}
              >
                <img
                  className="h-6 w-6"
                  alt="tick"
                  src={require("../../assets/icons/info-filled-grey.png")}
                />
                <p className="text-darkgray text-base italic font-sans">
                  {sentence?.Reason.split(regex)}
                </p>
              </div>
            )}
          </div>
        ))
      ) : (
        <>
          <div
            className={`flex flex-col p-5 border border-grey2 border-b-0 leading-[150%] rounded-t-lg`}
          >
            <div className="flex space-x-4">
              <img
                className="h-6 w-6"
                alt="tick"
                src={require("../../assets/icons/info-filled-orange.png")}
              />
              <div className="flex flex-col space-y-1">
                <h1 className="uppercase text-base font-bold text-darkgray font-sans">
                  original
                </h1>
                <p className="text-darkgray text-base font-sans">
                  {boldText(original)}
                </p>
              </div>
            </div>
          </div>
          <div
            className={`flex p-5 border border-grey2 border-t-0 space-x-4 leading-[150%]${reason ? " border-b-0" : " rounded-b-lg"}`}
          >
            <img
              className="h-6 w-6"
              alt="tick"
              src={require("../../assets/icons/tick-filled-green.png")}
            />
            <div className="flex flex-col space-y-1">
              <h1 className="uppercase text-base font-bold text-darkgray font-sans">
                suggested
              </h1>
              <p className="text-darkgray text-base font-sans">
                {boldText(corrected)}
              </p>
            </div>
          </div>
          {reason && (
            <div className="bg-green3 rounded-b-lg flex p-5 border border-grey2 border-t-0 space-x-4 leading-[150%]">
              <img
                className="h-6 w-6"
                alt="tick"
                src={require("../../assets/icons/info-filled-grey.png")}
              />
              <p className="text-darkgray text-base italic font-sans">
                {reason.split(regex)}
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default function GrammarCheck() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const userId = params.get("userId");
  const assessmentId = params.get("assessmentId");
  const flow = params.get("flow");
  const userType = params.get("userType") || params.get("usertype");
  const recordid = params.get("recordid");

  const [grammarData, setGrammarData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const grammarDataJson = await getGrammarData(
          userId,
          assessmentId,
          userType,
          recordid
        );
        if (grammarDataJson.CopyEdit) {
          setGrammarData(grammarDataJson.CopyEdit);
        } else {
          setGrammarData(grammarDataJson.sentences);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

 const handleNavigate = () => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        event: "trackMixpanelEventDuration",
        meta: {
          action: "BACK_ACCURACY_CHECK",
        },
      })
    );
  }

  const queryParams = new URLSearchParams({
    userId,
    assessmentId,
    userType,
    flow,
  });

  if (recordid) {
    queryParams.append("recordid", recordid);
  }

  navigate(`/ai-assessment/?${queryParams.toString()}`, {
    state: { index: 1 },
  });
};
  return (
    <div className="flex flex-col items-center justify-start w-full h-screen py-10 space-y-6">
      <div className="flex items-center justify-between w-full px-8">
        <div className="relative flex align-middle justify-center w-full">
          <h1 className="text-2xl font-semibold text-darkgray">
            Grammar Check
          </h1>
          <img
            className="h-9 w-9 absolute left-0 cursor-pointer"
            alt="cross"
            src={require("../../assets/icons/arrow-left-outlined-grey.png")}
            onClick={handleNavigate}
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-scroll px-8 space-y-6">
        {grammarData &&
          grammarData.map((grammarComparison, index) => (
            <GrammarCompare data={grammarComparison} key={index} />
          ))}
      </div>
    </div>
  );
}
